module.exports = __webpack_public_path__ + "static/insoddisfazione-b4ef5d52d00760bbe5f4e88818a28cf9.jpg";